<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import DatePickerInput, {
        dateNullable,
    } from '$components/Date/DatePickerInput.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import Input from '$components/Form/Input.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const travelTypeOptions = [
        `Vacances`,
        `Voyage d'affaires`,
        `Visa`,
        `Visite familiale`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const serviceTypeOptions = [
        `Billet d'avion`,
        `Réservation d'hôtel`,
        `Assurance voyage`,
        `Location de voiture`,
        `Circuit touristique`,
        `Change d'argent`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.agenceVoyage.travelType}
        class=""
        let:field
        let:id
        label={`Quel type de voyage souhaitez-vous planifier ?`}
        helpLabel="Maximum 2"
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            max={2}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={travelTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.agenceVoyage.serviceType}
        class=""
        let:field
        let:id
        label={`Quel service vous intéresse le plus ?`}
        helpLabel="Maximum 3"
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            max={3}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={serviceTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.agenceVoyage.destination}
        class=""
        let:field
        let:id
        label={`Quelle est votre destination ou votre pays d'arrivée ?`}
    >
        <Input
            {form}
            {id}
            {field}
            toText={(v) => v ?? ''}
            fromText={(str) => (str === '' ? null : str)}
            required={false}
            placeholder="Saisissez votre destination"
        />
    </Row>

    <Row {form} field={fields.agenceVoyage.travelDateStart} label={'Date souhaitées'}>
        <div class="grid grid-cols-1 @2xl:grid-cols-2 gap-8">
            <Row
                {form}
                field={fields.agenceVoyage.travelDateStart}
                label={'Aller'}
                let:field
            >
                <DatePickerInput futureDateOnly {field} {form} {...dateNullable} />
            </Row>

            <Row
                {form}
                field={fields.agenceVoyage.travelDateEnd}
                label={'Retour'}
                let:field
            >
                <DatePickerInput futureDateOnly {field} {form} {...dateNullable} />
            </Row>
        </div>
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin, soyez le plus précis dans votre demande de devis"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin, soyez le plus précis dans votre demande de devis`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
